<template>
  <div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>作品名称
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="30" placeholder="请输入作品名称"
            v-model="info.zpname"
            :disabled="isLocked()" />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>作品负责人
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="30" placeholder="请输入作品负责人"
            v-model="info.principals"
            :disabled="isLocked()" />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div class="main-text-style">
        <span style="color: #f6350f">*</span> 大赛分组
      </div>
      <div class="pl16">
        <a-select ref="select" v-model="info.levelType" :disabled="isLocked()"
              class="com-aspect" style="width: 280px">
              <a-select-option :value="item.value" :key="item.value" 
                 v-for="(item) in schoollist">
                {{ item.label }}
              </a-select-option>
        </a-select>
        <!-- <a-radio-group v-model="info.courseType" @change="onChange">
          <a-radio value="1"> 公共 </a-radio>
          <a-radio value="2"> 专业 </a-radio>
          <a-radio value="3"> 实践 </a-radio>
        </a-radio-group> -->
      </div>
    </div>
    <!-- <div class="mt30">
      <div class="main-text-style">
        <span style="color: #f6350f">*</span> 团队类型
      </div>
      <div class="pl16">
        <a-radio-group v-model="info.teamType" :disabled="isLocked()">
          <a-radio value="teacher">教师团队</a-radio>
          <a-radio value="student">学生团队</a-radio>
        </a-radio-group>
      </div>
    </div> -->
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>团队成员(非本校教师注明所属学校,如xx(xx学校))
        </div>
        <div class="pl16">
          <template v-for="(tag,index) in tags">
            <a-tag class="com-aspect text-center" :key="index" :closable="!isLocked()"
              @close="() => handleClose(tag)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input v-if="inputVisible" ref="input" type="text" size="small"
            :style="{ width: '150px' }" :value="inputValue" @change="handleInputChange"
            @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" :maxLength="30"
            class="com-aspect text-left" />
          <a-tag v-else-if="!isLocked() && tags.length < 20" style="
              background: #fff;
              borderstyle: dashed;
              display: inline-block;
              width: 150px;
            " @click="showInput" class="com-aspect text-center">
            <a-icon type="plus" />添加成员
          </a-tag>
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>学校名称
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="50"
            placeholder="请输入学校名称"
            v-model="info.schoolName"
            :disabled="isLocked()" />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>学校意见
        </div>
        <div class="pl16">
          <a-input class="input-style-2 input-style-text" type="textarea" :maxLength="30" placeholder="请输入学校意见"
            v-model="info.suggestion"
            :disabled="isLocked()" />
        </div>
      </div>
    </div>
    <div class="submit-btn" @click="goStep">下 一 步</div>
  </div>
</template>

<script>
import { checkName,getMajor1,getMajor2,getMajor3} from '@/api/index';
import { getAction } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    editInfoStep1: {
      type: Object,
    },
    lockFromEnroll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list1: [
        {
          key: 1,
          value: '中职思政课程组',
        },
        {
          key: 2,
          value: '中职公共基础课程组',
        },
        {
          key: 3,
          value: '中职专业技能课程一组',
        },
        {
          key: 4,
          value: '中职专业技能课程二组',
        },
      ],
      list2: [
        {
          key: 5,
          value: '高职思政课程组',
        },
        {
          key: 6,
          value: '高职公共基础课程组',
        },
        {
          key: 7,
          value: '高职专业课程一组',
        },
        {
          key: 8,
          value: '高职专业课程二组',
        },
      ],
      schoolType: Number(
        JSON.parse(sessionStorage.getItem('userInfo')).schoolType
      ),
      schoollist:[],
      info: {
        name: '',
        zpname:'',
        levelType:null,
        teamType: 'teacher',
        // levelTypeText: this.fSetLevelTypeText(),
        // levelType: this.fSetLevelType(),
        // major1:'',
        // major1_dictText:"",
        // major2:'',
        // major2_dictText:"",
        // major3:'',
        // major3_dictText:"",
        // phone: '',
        principals: '',
        teams: '',
        schoolName: '', // 学校名称（新增字段，列表同步展示）
        suggestion:'',
      },
      // major1Opt:'',
      // major2Opt:'',
      // major3Opt:'',
      // levelTypeText: '',
      tags: [],
      inputVisible: false,
      inputValue: '',
      id:'',
      // xtlist:[],
    };
  },
  computed: {},
  watch: {
    editInfoStep1: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.applyEnrollData(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    this.getschool();
    const fromEnroll = this.lockFromEnroll || this.$route.params.fromEnroll;
    if (fromEnroll && this.$route.params && Object.keys(this.$route.params).length > 0) {
      // console.log(this.$route.params,"fromEnroll");
      sessionStorage.setItem('qbsj', JSON.stringify(this.$route.params));
      this.applyEnrollData(this.$route.params);
    } else if (this.$route.params && this.$route.params.zpname) {
      this.applyEnrollData(this.$route.params);
    }
    // console.log(this.$route.params,"4444");
    if (
      this.$route.params.id != '' &&
      this.$route.params.id != null &&
      this.$route.params.id != undefined
    ) {
      sessionStorage.setItem('qbsj', JSON.stringify(this.$route.params));
    }else{
      // ===== 旧逻辑（保留备用）：qbsj 为空时会把 null 写成字符串 "null"，JSON.parse 后为 null，读 .id 直接报错 =====
      // sessionStorage.setItem('qbsj', sessionStorage.getItem('qbsj'));
      //   if(sessionStorage.getItem('qbsj') != undefined){
      //     const sjInfo = JSON.parse(sessionStorage.getItem('qbsj'));
      //     this.applyEnrollData(sjInfo);
      //     if(sjInfo.id){
      //       this.id = sjInfo.id;
      //       // this.info.id = sjInfo.id;
      //     }else{
      //        this.lockFromEnroll = true;
      //     }
      //   }
      const sjInfo = this.readQbsj();
      if (sjInfo) {
        this.applyEnrollData(sjInfo);
        if (sjInfo.id) {
          this.id = sjInfo.id;
        } else {
          this.lockFromEnroll = true;
        }
      }
    }
    if (!fromEnroll) {
      const oldInfo = JSON.parse(
        sessionStorage.getItem(`step${this.$store.state.user.id}`)
      );
      if (oldInfo) {
        this.applyEnrollData(oldInfo);
        this.id = oldInfo.id;
        // this.info.id = oldInfo.id;
      }
      // ===== 旧逻辑（保留备用）=====
      // if (sessionStorage.getItem('qbsj') != undefined) {
      //   const sjInfo = JSON.parse(sessionStorage.getItem('qbsj'));
      //   this.applyEnrollData(sjInfo);
      //   if(sjInfo.id){
      //     this.id = sjInfo.id;
      //     // this.info.id = sjInfo.id;
      //   }
      // }
      const sjInfo = this.readQbsj();
      if (sjInfo) {
        this.applyEnrollData(sjInfo);
        if (sjInfo.id) {
          this.id = sjInfo.id;
        }
      }
    }
  },
  methods: {
    // 读取缓存的申报记录：菜单直接进入时 qbsj 可能已被清空，
    // 缓存里也可能是字符串 "null" / "undefined" 或非法 JSON，统一兜底返回 null，避免读到 null.id 报错
    readQbsj() {
      try {
        const raw = sessionStorage.getItem("qbsj");
        if (!raw || raw === "null" || raw === "undefined") return null;
        return JSON.parse(raw) || null;
      } catch (e) {
        return null;
      }
    },
    isLocked() {
      return this.lockFromEnroll || (this.$parent.editInfo && this.$parent.editInfo.type == 'preview');
    },
    normalizeLevelType(val) {
      if (val === null || val === undefined || val === '') return null;
      const n = Number(val);
      return Number.isNaN(n) ? val : n;
    },
    applyEnrollData(source) {
      if (!source) return;
      if (source.zpname) this.info.zpname = source.zpname;
      if (source.principals) this.info.principals = source.principals;
      if (source.schoolName) this.info.schoolName = source.schoolName;
      if (source.suggestion) this.info.suggestion = source.suggestion;
      if (source.levelType !== undefined && source.levelType !== null && source.levelType !== '') {
        this.info.levelType = this.normalizeLevelType(source.levelType);
      }
      if (source.teamType) this.info.teamType = source.teamType;
      if (source.teams) {
        this.info.teams = source.teams;
        this.tags = String(source.teams).split(',').filter(Boolean);
      }
    },
    getschool() {
      // 网络育人创新联盟：大赛分组与大赛报名一致（1 中职组 / 2 高职组）
      this.schoollist = [
        { value: 1, label: '中职组' },
        { value: 2, label: '高职组' },
      ];
    },
    getxt(){
      getAction("/sys/ng-alain/getDictItems/example_subject", {}).then((res) => {
        this.xtlist = res;
      });
    },
    getMajorD(){
      getMajor1().then(res=>{
        if(res.success){
          this.major1Opt = res.result;
        }
      }).then(err=>{
        console.log(err)
      }) 
    },
    editMajor(){
      getMajor2({categoryId:this.info.major1}).then(res=>{
        this.major2Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
      getMajor3({subclassId:this.info.major2}).then(res=>{
        this.major3Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
    },
    major1Change(value,option){
      this.info.major1 = option.data.attrs['data-key'];
      this.info.major1_dictText = option.data.key
      this.info.major2_dictText = ""
      this.info.major3_dictText = ""
      this.info.major2 = ""
      this.info.major3 = ""

      getMajor2({categoryId:this.info.major1}).then(res=>{
        this.major2Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
    },
    major2Change(value,option){
      this.info.major2 = option.data.attrs['data-key'];
      // this.$set(this.info,'major3',' ')
      this.info.major2_dictText = option.data.key
      this.info.major3_dictText = ""
      getMajor3({subclassId:this.info.major2}).then(res=>{
        this.major3Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
      this.info.major3 = ""
    },
    major3Change(value,option){
      this.info.major3 = option.data.attrs['data-key'];
      this.info.major3_dictText = option.data.key;
      this.$forceUpdate();
//    console.log(this.info.major3)
    },
    fSetLevelTypeText(){
      var schoolType = JSON.parse(sessionStorage.getItem('userInfo')).schoolType;
      if(schoolType == 1){
        return '中职思政课程组'
      }else if(schoolType == 2){
        return '高职思政课程组'
      }
    },
    fSetLevelType(){
      var schoolType = JSON.parse(sessionStorage.getItem('userInfo')).schoolType;
      if(schoolType == 1){
        return 1
      }else if(schoolType == 2){
        return 5
      }
    },
    handleClose(removedTag) {
      if (this.isLocked()) return;
//    console.log(removedTag,'removedTag')
      const tags = this.tags.filter((tag) => tag !== removedTag);
      // console.log(tags,'tags')
      this.tags = tags;
    },
    showInput() {
      if (this.isLocked()) return;
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      if (this.isLocked()) return;
      const inputValue = this.inputValue;
      if (inputValue.length > 30) {
        return false;
      }
      let tags = this.tags;
      if (tags.length >= 20) {
        this.$message.warn('团队成员不能超过个20成员！');
        return false;
      }
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    getGroupList(schoolType) {
      if (schoolType == 1) return this.list1;
      return this.list2;
    },
    handleChange(value, option) {
      this.info.levelType = option.data.attrs['data-key'];
      this.info.major1 = "";
      this.info.major1_dictText = "";
      this.info.major2 = "";
      this.info.major2_dictText = "";
      this.info.major3 = "";
      this.info.major3_dictText = "";
//    console.log(this.info.levelType,'11111');
    },
    goStep() {
//    if (
//      (this.info && this.info.name.trim() === '') ||
//      this.info.name == undefined
//    ) {
//      this.$message.info('请填写课程名称');
//      return false;
//    }
      if ( this.info && (this.info.zpname == undefined || this.info.zpname == null || this.info.zpname.trim() === '') ){
        this.$message.info('请填写作品名称');
        return false;
      }
      //  if ( this.info && (this.info.name == undefined || this.info.name == null || this.info.name=== '') ){
      //   this.$message.info('请选择案例选题');
      //   return false;
      // }

//    if(this.info.levelType == 3 || this.info.levelType == 4 || this.info.levelType == 7 || this.info.levelType == 8){
//      if ( this.info.major1 == undefined || this.info.major1 == "") {
//        this.$message.info('请选择专业大类');
//        return false;
//      }
//      if ( this.info.major2 == undefined || this.info.major2 == "") {
//        this.$message.info('请选择专业子类');
//        return false;
//      }
//      if ( this.info.major3 == undefined || this.info.major3 == "") {
//        this.$message.info('请选择专业分类');
//        return false;
//      }
//    }
//    if(this.info.major1){
//      if(this.info.major2 == undefined ||  this.info.major2 == ""  || this.info.major2 == null){
//        this.$message.info('请选择专业子类');
//        return false;
//      }
//    }
//    if(this.info.major2){
//      if(this.info.major3 == undefined ||  this.info.major3 == ""  || this.info.major3 == null){
//        this.$message.info('请选择专业分类');
//        return false;
//      }
//    }
      if (
        (this.info && this.info.principals.trim() === '') ||
        this.info.principals == undefined
      ) {
        this.$message.info('请填写作品负责人');
        return false;
      }
      // if (
      //   (this.info && this.info.phone === '') ||
      //   this.info.phone == undefined
      // ) {
      //   this.$message.info('请输入手机号');
      //   return false;
      // } else {
      //   var telStr = /^[1]([3-9])[0-9]{9}$/;
      //   if (!telStr.test(this.info.phone)) {
      //     this.$message.info('请输入正确格式手机号');
      //     return false;
      //   }
      // }
      if(this.tags.length=='0'){
      	 this.$message.info('请上传团队成员');
      	 return false;
      }
      if (!this.info.schoolName || !String(this.info.schoolName).trim()) {
      	 this.$message.info('请填写学校名称');
      	 return false;
      }
      if (
        (this.info && this.info.suggestion.trim() === '') ||
        this.info.suggestion == undefined
      ) {
        this.$message.info('请填写学校意见');
        return false;
      }
      // 校验重复
      let applyType=4;
//    console.log(this.id);
      checkName({
        zpname: this.info.zpname,
        id: this.$route.params.id?this.$route.params.id:this.id,
        applyType: applyType,
      }).then((res) => {
        if (res.message == '信息可用') {
          this.info.teams = this.tags.join(',');
//        console.log(this.info)
          // if(this.info.levelType == 1 ||this.info.levelType == 2  ||this.info.levelType == 5  || this.info.levelType == 6  ){
          //   this.info.major1 = "";
          //   this.info.major2 = "";
          //   this.info.major3 = "";
          // }
          // sessionStorage.setItem('qbsj', JSON.stringify(this.info));
          this.$emit('goStep', this.info);
        } else {
          this.$message.info(res.message);
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.input-style-text{
  height: 162px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.com-aspect {
  min-width: 88px;
  height: 54px;
  font-size: 16px;
  line-height: 54px;
  position: relative;
  padding-right: 24px;
  /deep/ .anticon-close{
    position: absolute;
    top: 50%;
    right: 10px;
    transform:translateY(-50%);
  }
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
/deep/.com-aspect.ant-select > div {
  width: 100%;
  height: 100%;
  .ant-select-selection__rendered {
    font-size: 18px;
    line-height: 54px;
  }
}
</style>
